import React from 'react'
import gullfood from '../assets/images/events/tn_gulfood-vs-klein.png'
import sialparis from '../assets/images/events/sialparis.png'
import anuga from '../assets/images/events/tn_tn_anuga2.jpg'
import AmricanFood from '../assets/images/events/tn_americas1.jpg'
import { t } from 'i18next';

export const EnventsPage = () => {

    const eventdata = [
        {
            id: 1,
            image: gullfood,
            name: 'GulFood',
            date_one: t('events.gullfood.date_one'),
            date_two: t('events.gullfood.date_two'),
            location: 'Dubai World Trade Centre, Dubai - ARE',
            content: t('events.gullfood.title'),
            link: 'https://www.gulfood.com'
        },
        {
            id: 2,
            image: sialparis,
            name: 'SIAL Paris',
            date_one: t('events.sailparis.date_one'),
            date_two: t('events.sailparis.date_two'),
            location: 'Paris Nord Villepite, France - FRA',
            content: t('events.sailparis.title'),
            link: 'https://www.sialparis.com/'
        },
        {
            id: 3,
            image: AmricanFood,
            name: 'Americas Food and Beverage Show & Conference',
            date_one: t('events.amricanfood.date_one'),
            date_two: t('events.amricanfood.date_two'),
            location: 'Miami Beach Convention Center, Miami Beach, Florida, U.S.A - USA',
            content: t('events.amricanfood.title'),
            link: 'https://www.americasfoodandbeverage.com/'
        },
        {
            id: 4,
            image: anuga,
            name: 'Anuga',
            date_one: t('events.Anuga.date_one'),
            date_two: t('events.Anuga.date_two'),
            location: 'Cologne - DEU',
            content: t('events.Anuga.title'),
            link: 'https://www.anuga.com/'
        },

    ];
    return (
        <div className='mb-10'>
            <div
                data-aos="zoom-in"
                data-aos-duration="300"
            >

                <p className='my-3 text-4xl text-[#800000] font-bold text-center'>{t('events.heading1')}</p>
                <p className="text-blue-gray-400 text-[15px] text-center leading-6 mx-auto max-w-xs md:max-w-md mt-2 text-gray-500 font-medium mb-4">
                    {t('events.heading2')}
                </p>
            </div>



            {eventdata && eventdata.map((item, index) =>
                <div
                    data-aos="zoom-in"
                    data-aos-duration="500"
                >
                    <div class="mx-4 md:mx-40 flex flex-row md:flex-row mt-10 space-y-4 md:space-x-6 justify-center">
                        <div class="w-full md:w-52 h-30 object-cover">
                            <img class="w-32 h-32 object-contain" src={item.image} alt="" />
                        </div>
                        <div>
                            <h1 class="text-xl font-serif text-[#800000] ">{item.name}</h1>
                            <div class="text-blue-gray-400 text-[15px] text-gray-500 font-medium">
                                <time datetime="2024-01-29">{item.date_one}</time> - <time datetime="2024-02-01">{item.date_two}</time>
                            </div>
                            <div class="text-blue-gray-400 text-[15px] text-gray-500 font-medium mb-3">
                                {item.location}
                            </div>
                           
                            <p class="text-blue-gray-400 text-[15px] max-w-3xl text-gray-500 font-sm">
                                {item.content.charAt(0).toUpperCase() + item.content.slice(1).toLowerCase()}                            </p>
                            <a class="text-blue-gray-400 text-[15px] text-[#800000] font-medium border-b-2 border-[#800000]" href={item.link}>{t('events.link')}</a>
                        </div>
                    </div>
                </div>
            )}
        </div>

    )
}
